import React, { useContext } from "react";

// Context imports
import { SuperTimesheetContext } from "../../../context/page/SuperTimesheetContext";

// Utility functions
import { formatDate } from "../../../utils";

/**
 * Displays the users name and the week ending date for their timesheet.
 */
const Title = ({ worker, className }) => {
  const { weekEnding } = useContext(SuperTimesheetContext);

  return (
    <div
      className={`grid grid-cols-2 grid-rows-2 gap-0 w-full rounded ${className}`}
    >
      <div className="bg-green-900 text-white p-2 font-bold rounded-tl flex items-center justify-center">
        Worker
      </div>
      <div className="bg-green-900 text-white p-2 font-bold rounded-tr flex items-center justify-center">
        Week Ending
      </div>
      <div className="bg-gray-200 p-2 rounded-bl flex items-center justify-center">
        {worker.first} {worker.last}
      </div>
      <div className="bg-gray-200 p-2 rounded-br flex items-center justify-center">
        {weekEnding ? formatDate(weekEnding, "d month DD, YYYY") : "N/A"}
      </div>
    </div>
  );
};

export default Title;
